/**
 * TanStack Query key factory for Workbench artefacts.
 *
 * Matches the convention used by `versions/services/queryKeys.ts` —
 * stable, scope-aware keys so cache invalidation is precise.
 */
export const artefactKeys = {
  all: ["artefacts"] as const,
  byProject: (projectId: string, includeArchived = false) =>
    [...artefactKeys.all, "project", projectId, { includeArchived }] as const,
  detail: (projectId: string, artefactId: string) =>
    [...artefactKeys.all, "project", projectId, "detail", artefactId] as const,
  /** Live Workbench overview — computed read, not a persisted
   *  artefact. Cached separately from the artefact list so a
   *  "Snapshot inventory" capture invalidates the list but leaves
   *  the live overview cached (it'd just re-fetch the same numbers). */
  workbenchOverview: (projectId: string) =>
    [...artefactKeys.all, "workbench-overview", projectId] as const,
};
